export const isLink = str => typeof str === 'string' && (str?.startsWith('http://') || str?.startsWith('https://'))
